import React from "react";
//#region types
import { StyleEnums } from "models/enums";
import { TranslationKeys } from "translations";
import { VoucherDetailsViewProps } from "models/propTypes/voucherPropsTypes";
import { ImageMeta } from "models/propTypes/fileViewerPropTypes";
//#endregion
//#region components
import { FileViewerContainer, PageLayouts, EntityTitle, useMountedState } from "components/common";
import ManualVoucher from "./manuelVoucher";
import VoucherFooter from "./footer";
import { useVoucherService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const VoucherDetailsView: React.FC<VoucherDetailsViewProps> = (props) => {
  const voucherService = useVoucherService();
  const { voucher } = props;
  const { getMounted } = useMountedState();

  const [attachments, setAttachments] = React.useState<ImageMeta[]>([]);

  React.useEffect(() => {
    const attachments: ImageMeta[] =
      voucher.attachments && voucher.attachments.numberOfAttachments > 0 && voucher.attachments.attachmentsMeta
        ? voucher.attachments.attachmentsMeta.map((x) => ({
            id: x.attachmentId ?? "",
            contentType: x.contentType,
            numberOfPages: x.numberOfPages,
          }))
        : [];

    setAttachments(attachments);
  }, [voucher?.id, voucher?.attachments, getMounted]);

  const onDownloadClick = async () => {
    return voucherService.downloadVoucher(voucher?.id ?? "");
  };

  return (
    <PageLayouts.EntityViewLayout
      displayType={StyleEnums.DisplayType.Info}
      upperLeftComponent={
        <EntityTitle
          subTitle={`${LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Accounting.ManualPayment)} - ${
            voucher.number
          }`}
          title={voucher.text ?? ""}
        />
      }
      lowerLeftComponent={
        <FileViewerContainer
          meta={attachments}
          parentId={voucher.id}
          onDownloadClick={onDownloadClick}
          getFile={voucherService.getVoucherImage}
        />
      }
      upperRightComponent={<></>}
      footer={<VoucherFooter voucher={voucher} />}
    >
      <ManualVoucher voucher={voucher} />
    </PageLayouts.EntityViewLayout>
  );
};
export default VoucherDetailsView;
